export const Partners = () => {
  return (
    <div className="container" style={{ paddingTop: '24px' }}>
      <h1>Партнерская программа</h1>
      <p>Информация о партнерской программе...</p>
    </div>
  );
};